import Icon from '@components/Icon';
import Text from '@components/Text';
import { ReactNode } from 'react';

import styles from './styles.module.scss';

interface Props {
    children?: ReactNode;
    leadingIcon?: string;
    trailingIcon?: string;
    isError?: boolean;
}

function Description(props: Props) {
    const {
        children, leadingIcon, trailingIcon, isError,
    } = props;
    const isText = typeof children === 'string';
    return (<div className={`${styles.description} ${isError && styles.error}`}>
        {leadingIcon && <Icon name={leadingIcon}/>}
        {isText ? (
            <Text size='s'
                className={`${styles.text} ${isError && styles.error}`}>
                {children}
            </Text>
        ) : (<div className={`${styles.text} ${styles.error}`}>
            {children}
        </div>)}
        {trailingIcon && <Icon name={trailingIcon}/>}
    </div>);
}

export default Description;
